function Breadcrumb(info) {
  return (
    <div className="bread_img">
      <img src={info.img} alt="St francis Amristar" />

      <div className="innerhead-content">
        <h1 className="title1">{info.title}</h1>
        <br />
        <h1>{info.title2}</h1>

        <div className="Breadcrumb">
          <ul>
            <li>
              <a href="/">
                <i className="bi bi-house-fill me-2"></i>
              </a>
            </li>

            {info.parentTitle && (
              <>
                <span>&gt;</span>
                <li>
                  <a href={info.parentLink}>{info.parentTitle}</a>
                </li>
              </>
            )}

            <span>&gt;</span>
            <li>{info.path}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Breadcrumb;
